import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {authPath, rootMainPath} from '../../routes/paths';
import ButtonMUI from '../../shared/ButtonMUI';

import SuccessfullyBg from '../../assets/images/auth/Successfully.jpg';
import {useTranslation} from 'react-i18next';

const SuccessfullyRecovery = () => {
  const {t} = useTranslation();
  const history = useHistory();

  useEffect(() => {
    localStorage.getItem('token') && history.push(rootMainPath);
  }, []);

  return (
    <div className='auth-page__content'>
      <div className='auth-page__bg'>
        <img className='employee' src={SuccessfullyBg} alt='AuthBg' />
      </div>
      <div className='auth-box__wrapper successfully'>
        <div />

        <div className='auth-box successfully'>
          <div className='auth-box__descriptions'>{t('auth.passwordResetEmailSent')}</div>

          <ButtonMUI component={Link} to={authPath.signIn}>
            {t('auth.close')}
          </ButtonMUI>
        </div>

        <div className='auth-box__subscribe successfully__subcribe'>
          {t('SideBgFooter.copyright', {year: new Date().getFullYear()})}
        </div>
      </div>
    </div>
  );
};

export default SuccessfullyRecovery;
